import { PrimaryButton } from "@fluentui/react/lib/Button"
import { Dialog, DialogFooter, DialogType } from "@fluentui/react/lib/Dialog"
import { IProcessedStyleSet } from "@fluentui/react/lib/Styling"
import { classNamesFunction, styled } from "@fluentui/react/lib/Utilities"
import React, { useEffect, useState } from "react"

import { L10n } from "@encoway/l10n"

import { Events } from "../../constants"
import { ARDialogStyles } from "./ARDialog.styles"
import { IARDialogStyles, ARDialogProps } from "./ARDialog.types"

/**
 * The ARDialog component renders a dialog with the response from AR service, including a QR code.
 *
 * Links:
 * - [Checkout the code](https://gitlab.encoway-services.de/pd/dev/encoway-cpq/-/blob/master/cui/features/application-components/src/components/ARDialog/ARDialog.tsx)
 * - [ARDialogStyles](https://gitlab.encoway-services.de/pd/dev/encoway-cpq/-/blob/master/cui/features/application-components/src/components/ARDialog/ARDialog.styles.ts)
 * - [ARDialogProps](https://gitlab.encoway-services.de/pd/dev/encoway-cpq/-/blob/master/cui/features/application-components/src/components/ARDialog/ARDialog.types.ts)
 * - [MS Fluent Dialog](https://developer.microsoft.com/de-DE/fluentui#/controls/web/dialog)
 *
 * @visibleName ARDialog
 */
export function IARDialog(props: ARDialogProps) {
    const { styles, theme, eventBus } = props
    const classNames = classNamesFunction()(
        styles,
        theme
    ) as IProcessedStyleSet<IARDialogStyles>

    const [state, setState] = useState({
        show: false,
        link: null,
        qr: null
    })

    useEffect(() => {
        const unregister = eventBus
            .filter((e: any) => e.type === Events.ShowARDialog)
            .onValue((e: any) =>
                setState({ show: true, link: e.link, qr: e.qr })
            )
        return () => unregister()
    }, [])

    if (!state.show) {
        return null
    }

    const title = props.title || "Application.Visualization.AR.title"
    const message = props.message || "Application.Visualization.AR.message"

    const dialogContentProps = {
        type: DialogType.normal,
        title: L10n.format(title),
        subText: L10n.format(message),
        styles: { subText: { whiteSpace: "pre-line" } }
    }

    return (
        <Dialog
            hidden={false}
            dialogContentProps={dialogContentProps}
            modalProps={{
                className: classNames.root,
                ...props.modalProps
            }}
            maxWidth="auto"
        >
            {state.qr && state.link && (
                <a
                    className={classNames.qr}
                    target="_blank"
                    rel="noreferrer"
                    href={state.link}
                >
                    <img src={state.qr} alt="QR_CODE" />
                </a>
            )}
            <DialogFooter className={classNames.footer}>
                <PrimaryButton
                    onClick={() =>
                        setState({ show: false, link: null, qr: null })
                    }
                    text={L10n.format("Close")}
                    className={classNames.button}
                />
            </DialogFooter>
        </Dialog>
    )
}

export const ARDialog = styled(IARDialog, ARDialogStyles)
